import _classCallCheck from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _get from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/get";
import _inherits from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/button/switchbuttonview
 */
import View from "../view";
import ButtonView from "./buttonview";
import "../../theme/components/button/switchbutton.css";
/**
 * The switch button view class.
 *
 *		const view = new SwitchButtonView();
 *
 *		view.set( {
 *			withText: true,
 *			label: 'Switch me!'
 *		} );
 *
 *		view.render();
 *
 *		document.body.append( view.element );
 *
 * @extends module:ui/button/buttonview~ButtonView
 */

var SwitchButtonView =
/*#__PURE__*/
function (_ButtonView) {
  _inherits(SwitchButtonView, _ButtonView);

  /**
   * @inheritDoc
   */
  function SwitchButtonView(locale) {
    var _this;

    _classCallCheck(this, SwitchButtonView);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SwitchButtonView).call(this, locale));
    _this.isToggleable = true;
    /**
     * The toggle switch of the button.
     *
     * @readonly
     * @member {module:ui/view~View} #toggleSwitchView
     */

    _this.toggleSwitchView = _this._createToggleView();

    _this.extendTemplate({
      attributes: {
        class: 'ck-switchbutton'
      }
    });

    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SwitchButtonView, [{
    key: "render",
    value: function render() {
      _get(_getPrototypeOf(SwitchButtonView.prototype), "render", this).call(this);

      this.children.add(this.toggleSwitchView);
    }
    /**
     * Creates a toggle child view.
     *
     * @private
     * @returns {module:ui/view~View}
     */

  }, {
    key: "_createToggleView",
    value: function _createToggleView() {
      var toggleSwitchView = new View();
      toggleSwitchView.setTemplate({
        tag: 'span',
        attributes: {
          class: ['ck', 'ck-button__toggle']
        },
        children: [{
          tag: 'span',
          attributes: {
            class: ['ck', 'ck-button__toggle__inner']
          }
        }]
      });
      return toggleSwitchView;
    }
  }]);

  return SwitchButtonView;
}(ButtonView);

export { SwitchButtonView as default };